import React from "react";
import { Button, Modal, ModalBody } from "reactstrap";

interface AlertModalProps {
    isOpen: boolean;
    title?: string;
    message: string;
    type?: "success" | "danger" | "warning" | "info";
    onClose: () => void;
}

const AlertModal: React.FC<AlertModalProps> = ({
    isOpen,
    title,
    message,
    type = "info",
    onClose,
}) => {
    const typeClass = {
        success: "text-success",
        danger: "text-danger",
        warning: "text-warning",
        info: "text-info",
    }[type];

    const typeIcon = {
        success: "mdi-check-circle-outline",
        danger: "mdi-close-octagon-outline",
        warning: "mdi-alert-outline",
        info: "mdi-information-outline",
    }[type];

    return (
        <Modal
            size="sm"
            isOpen={isOpen}
            toggle={onClose}
            centered
            contentClassName="shadow rounded-4 border-0"
        >
            <ModalBody className="p-4 text-center">
                <div className={`fs-2 mb-3 ${typeClass}`}>
                    <i className={`mdi ${typeIcon}`}></i>
                </div>
                {title && <h6 className="mb-2 text-dark">{title}</h6>}
                <p className="mb-4 text-muted">{message}</p>
                <Button color="primary" className="px-4 fw-semibold" onClick={onClose}>
                    Đóng
                </Button>
            </ModalBody>
        </Modal>
    );
};

export default AlertModal;
